const environment = process.env.REACT_APP_ENV;

export const API_BASE =
  environment === "production" || environment === "prod"
    ? "https://demo.order2ucloud.com/veevareconcileservice"
    : `https://demo.${environment}.order2ucloud.com/veevareconcileservice`;
